// @flow

import * as React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import {useStripeClui} from '../helpers/react/provider';
import StripeCluiButtonLink from './ButtonLink';

type Props = {};

const stripeAsciiArt = `     _        _
 ___| |_ _ __(_)_ __   ___
/ __| __| '__| | '_ \\ / _ \\
\\__ \\ |_| |  | | |_) |  __/
|___/\\__|_|  |_| .__/ \\___|
               |_|
`;

const messages = defineMessages({
  welcome: {
    id: 'docsApp.clui.welcome',
    description:
      'Message that appears when the user opens the Stripe Shell (fka Stripe CLUI).',
    defaultMessage: `
Welcome to the Stripe Shell! This is a graphical user interface of the Stripe
CLI you can run in your browser to:
- <Command1Link>Listen to account activity</Command1Link>
- <Command2Link>Trigger events</Command2Link>
- <Command3Link>Manage Stripe resources</Command3Link>
`,
  },
});

const WelcomePrompt = (props: Props): React.Node => {
  const {
    invokeCommand,
    state: {panes},
  } = useStripeClui();
  return (
    <pre>
      <code className="CodeBlock">
        <div>{stripeAsciiArt}</div>
        <div>
          <FormattedMessage
            {...messages.welcome}
            values={{
              Command1Link: (label) => (
                <StripeCluiButtonLink
                  label={label}
                  onClick={(e) => {
                    e.stopPropagation();
                    const newPaneIdx = panes.length;
                    invokeCommand({
                      command: 'stripe listen',
                      paneIdx: newPaneIdx,
                    });
                  }}
                />
              ),
              Command2Link: (label) => (
                <StripeCluiButtonLink
                  label={label}
                  onClick={(e) => {
                    e.stopPropagation();
                    invokeCommand({
                      command: 'stripe trigger payment_intent.created',
                      paneIdx: 0,
                    });
                  }}
                />
              ),
              Command3Link: (label) => (
                <StripeCluiButtonLink
                  label={label}
                  onClick={(e) => {
                    e.stopPropagation();
                    invokeCommand({
                      command: 'stripe customers create',
                      paneIdx: 0,
                    });
                  }}
                />
              ),
            }}
          />
        </div>
      </code>
    </pre>
  );
};

export default WelcomePrompt;
